<template>
  <validation-observer ref="observer">
    <form @submit.prevent="submit">
      <h5 class="mb-2 text-uppercase">Projekt/Baustelle</h5>

      <validation-provider
        v-slot="{ errors }"
        name="Name"
        rules="required|max:50"
        mode="lazy"
      >
        <v-text-field
          v-model="site.name"
          :error-messages="errors"
          label="Projektname *"
          outlined
          color="grey darken-2"
        ></v-text-field>
      </validation-provider>
      <v-row class="py-0 my-0">
        <v-col cols="4" class="py-0 my-0">
          <validation-provider
            v-slot="{ errors }"
            name="postalCode"
            rules="required|postal_code:4"
            mode="lazy"
          >
            <v-text-field
              v-model="site.postal_code"
              :error-messages="errors"
              label="PLZ *"
              outlined
              color="grey darken-2"
            ></v-text-field>
          </validation-provider>
        </v-col>
        <v-col cols="8" class="py-0 my-0">
          <validation-provider
            v-slot="{ errors }"
            name="city"
            rules="required|max:20"
            mode="lazy"
          >
            <v-text-field
              v-model="site.city"
              :error-messages="errors"
              label="Stadt *"
              outlined
              color="grey darken-2"
            ></v-text-field>
          </validation-provider>
        </v-col>
      </v-row>
      <validation-provider
        v-slot="{ errors }"
        name="street"
        rules="required|max:50"
        mode="lazy"
      >
        <v-text-field
          v-model="site.street"
          :error-messages="errors"
          label="Straße *"
          outlined
          color="grey darken-2"
        ></v-text-field>
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        name="costCenter"
        rules="max:50"
        mode="lazy"
      >
        <v-text-field
          v-model="site.costCenter"
          :error-messages="errors"
          label="Kostenstelle"
          outlined
          color="grey darken-2"
        ></v-text-field>
      </validation-provider>

      <h5 class="mb-2 text-uppercase">Ansprechperson Baustelle</h5>

      <validation-provider
        v-slot="{ errors }"
        name="firstName"
        rules="required|max:30"
        mode="lazy"
      >
        <v-text-field
          v-model="site.contact_person_first_name"
          :error-messages="errors"
          label="Vorname *"
          outlined
          color="grey darken-2"
        ></v-text-field>
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        name="lastName"
        rules="required|max:30"
        mode="lazy"
      >
        <v-text-field
          v-model="site.contact_person_last_name"
          :error-messages="errors"
          label="Nachname *"
          outlined
          color="grey darken-2"
        ></v-text-field>
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        name="telephone"
        rules="required|max:50"
        mode="lazy"
      >
        <v-text-field
          v-model="site.contact_person_telephone"
          :error-messages="errors"
          label="Telefonnummer *"
          outlined
          color="grey darken-2"
        >
        </v-text-field>
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        name="position"
        rules="max:50"
        mode="lazy"
      >
        <v-text-field
          v-model="site.contact_person_position"
          :error-messages="errors"
          label="Position"
          outlined
          color="grey darken-2"
        >
        </v-text-field>
      </validation-provider>

      <v-checkbox
        v-model="secondContactPerson"
        label="Weitere Ansprechperson"
        class="ma-0"
      />

      <template v-if="secondContactPerson">
        <h5 class="mt-2 mb-2 text-uppercase">Ansprechperson Baustelle</h5>
        <validation-provider
          v-slot="{ errors }"
          name="firstName"
          rules="required|max:30"
          mode="lazy"
        >
          <v-text-field
            v-model="site.contact_person2_first_name"
            :error-messages="errors"
            label="Vorname *"
            outlined
            color="grey darken-2"
          ></v-text-field>
        </validation-provider>
        <validation-provider
          v-slot="{ errors }"
          name="lastName"
          rules="required|max:30"
          mode="lazy"
        >
          <v-text-field
            v-model="site.contact_person2_last_name"
            :error-messages="errors"
            label="Nachname *"
            outlined
            color="grey darken-2"
          ></v-text-field>
        </validation-provider>
        <validation-provider
          v-slot="{ errors }"
          name="telephone"
          rules="required|max:50"
          mode="lazy"
        >
          <v-text-field
            v-model="site.contact_person2_telephone"
            :error-messages="errors"
            label="Telefonnummer *"
            outlined
            color="grey darken-2"
          >
          </v-text-field>
        </validation-provider>
        <validation-provider
          v-slot="{ errors }"
          name="position"
          rules="max:50"
          mode="lazy"
        >
          <v-text-field
            v-model="site.contact_person2_position"
            :error-messages="errors"
            label="Position"
            outlined
            color="grey darken-2"
          >
          </v-text-field>
        </validation-provider>
      </template>

      <div class="my-4 text-center">
        <v-btn color="primary" type="submit" :loading="isSubmitting" outlined>
          Baustelle hinzufügen
        </v-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'FormAddSite',
  components: {},
  props: ['user'],
  data: () => ({
    isSubmitting: false,
    secondContactPerson: false,
    site: {
      name: '',
      postal_code: '',
      city: '',
      street: '',
      cost_center: '',
      company: '',
    },
  }),
  computed: {
    ...mapGetters([]),
  },
  watch: {
    user() {
      this.initUser();
    },
  },
  created() {
    this.initUser();
  },
  methods: {
    ...mapActions(['addSite']),
    initUser() {
      if (this.user) {
        this.site.contact_person_first_name = this.user.first_name;
        this.site.contact_person_last_name = this.user.last_name;
        this.site.contact_person_telephone = this.user.telephone;
        this.site.contact_person_position = '';
        this.site.contact_person2_first_name = '';
        this.site.contact_person2_last_name = '';
        this.site.contact_person2_telephone = '';
        this.site.contact_person2_position = '';
        this.site.company = this.user.company.id;
      }
    },
    submit() {
      this.$refs.observer.validate().then(async success => {
        if (!success) {
          return;
        }
        this.isSubmitting = true;
        try {
          const site = await this.addSite(this.site);
          this.$emit('submit', site);
          this.clear();
        } catch {
          // ignored
        }
        this.isSubmitting = false;
      });
    },
    clear() {
      this.site = {
        name: '',
        postal_code: '',
        city: '',
        street: '',
        cost_center: '',
        company: '',
      };
      this.$refs.observer.reset();
    },
  },
};
</script>
